import InvoiceCard from "./invoice-card"; // Fixed typo in component name
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import useVessel from "@/store/use-vessel";
import { useMemo, useState } from "react";
import { RiRefreshLine } from "@remixicon/react";
import { useSearchInvoices } from "@/services/queries/invoices";
import { useGetCurrencies } from "@/services/queries/currency";
import { useSearchParams } from "react-router-dom";
import { formatDate, parseDateParam } from "@/lib/utils";

const INITIAL_INVOICE_COUNT = 3;

const Expenses = () => {
  const { t, i18n } = useTranslation();
  const { selectedVessel } = useVessel();
  const [searchParams] = useSearchParams();
  const [showAll, setShowAll] = useState(false);
  const date = formatDate(
    parseDateParam(searchParams.get("date")),
    "yyyy-MM-dd"
  );

  const { data, isPending, refetch, isRefetching } = useSearchInvoices(
    {
      vesselId: selectedVessel?.id,
      startDate: date,
      endDate: date,
    },
    {
      enabled: !!selectedVessel,
    }
  );
  const { data: currenciesData } = useGetCurrencies();

  const currencies = useMemo(() => {
    return currenciesData?.value;
  }, [currenciesData]);

  const invoices = useMemo(() => {
    return data?.data.value?.items || [];
  }, [data]);

  const displayedInvoices = showAll
    ? invoices
    : invoices.slice(0, INITIAL_INVOICE_COUNT);
  const hasMore = invoices.length > INITIAL_INVOICE_COUNT;

  return (
    <div className="flex flex-col items-center justify-center px-5">
      <div className="flex w-full flex-row items-center justify-between">
        <h2 className="w-full text-start text-[15px] font-semibold leading-[15px] tracking-wide text-white">
          {t("title.invoices").toLocaleUpperCase(i18n.language)}
        </h2>
        <button
          onClick={() => refetch()}
          className="text-white"
          data-testid="refresh-button"
        >
          <RiRefreshLine size={18} />
        </button>
      </div>

      <div className="mt-5 flex w-full flex-col items-center justify-center gap-[10px]">
        {isPending || isRefetching ? (
          <Loading className="mt-10" />
        ) : invoices.length > 0 ? (
          <>
            {hasMore && showAll && (
              <button
                type="button"
                onClick={() => setShowAll(false)}
                className="w-full rounded-md border border-white/30 bg-white/10 py-2 text-sm font-medium text-white"
                data-testid="show-less-invoices"
              >
                {t("navigation.less")}
              </button>
            )}
            {displayedInvoices.map((invoice) => (
              <InvoiceCard
                key={invoice.id}
                invoice={invoice}
                currencies={currencies}
              />
            ))}
            {hasMore && !showAll && (
              <button
                type="button"
                onClick={() => setShowAll(true)}
                className="w-full rounded-md border border-white/30 bg-white/10 py-2 text-sm font-medium text-white"
                data-testid="show-more-invoices"
              >
                {t("navigation.more")}
              </button>
            )}
          </>
        ) : (
          <div className="mt-10 flex w-full flex-col items-center justify-center gap-[10px]">
            <p className="text-white">{t("label.no_invoices_found")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Expenses;
